import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        px: 3,
        py: 6,
        textAlign: "center",
        gap: 2,
      }}
    >
      {/* Icon */}
      <SearchOffIcon
        sx={{
          fontSize: 80,
          color: "text.disabled",
          mb: 1,
        }}
      />

      {/* 404 */}
      <Typography
        variant="h1"
        fontWeight={800}
        sx={{
          fontSize: { xs: "5rem", sm: "7rem" },
          lineHeight: 1,
          color: "text.disabled",
          letterSpacing: -4,
        }}
      >
        404
      </Typography>

      {/* Heading */}
      <Typography
        variant="h5"
        fontWeight={700}
        color="text.primary"
        sx={{ mt: 1 }}
      >
        Page Not Found
      </Typography>

      {/* Sub-text */}
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ maxWidth: 360 }}
      >
        The page you're looking for doesn't exist or has been moved.
      </Typography>

      {/* CTA */}
      <Button
        variant="contained"
        color="success"
        size="large"
        startIcon={<HomeOutlinedIcon />}
        onClick={() => navigate("/")}
        sx={{
          mt: 2,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          px: 4,
        }}
      >
        Go to Homepage
      </Button>
    </Box>
  );
}